// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"3c128a79","489":"b1c84cc3","506":"3c128a79","559":"3c128a79","818":"3c128a79","837":"b1c84cc3","887":"3c128a79"}[chunkId] + ".chunk.css";
};